export default {
    setFundFocus(state, value) {
        state.fundFocus = value;
    },
    setMarketCommentary(state, value) {
        state.marketCommentary = value;
    },
    setReadArticles(state, articles) {
        state.readArticles = articles;
    },
    setResearchReminders(state, array) {
        state.researchReminders = array;
    },
    removeArticleReminder(state, article) {
        state.researchReminders = state.researchReminders.filter((reminder) => reminder.id !== article.id);
    },
    setIsLoadingFundFocus(state, status) {
        state.isLoadingFundFocus = status;
    },
    setHasLoadedFundFocus(state, status) {
        state.hasLoadedFundFocus = status;
    },
};
